// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const B2E_DOMAIN = 'ross-applications-i.eu-central-1.aws.cloud.bmw';
const B2D_DOMAIN = 'ross-applications-i.aws.bmw.cloud';
const domain = window.location.hostname;
export const environment = {
  production: false,

  b2e: {
    serverURL:
      'https://ross-applications-i.eu-central-1.aws.cloud.bmw/api/ross/icd/v1',
    oauthDomainURL: 'https://us.int.alpha.sso.bmwgroup.com',
    issuer:
      'https://us.int.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha',
    redirectUri: 'https://ross-applications-i.eu-central-1.aws.cloud.bmw',
    clientId: '49418c4c-0388-451d-ab4e-1974d5a5d00d',
    responseType: 'code',
    scope: 'openid profile email bmwids organization b2xroles',
    loginUrl:
      'https://us.int.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha/authorize',
    requireHttps: true,
    oidc: true,
    showDebugInformation: true,
    userType: 'B2E',
    env: 'INT',
    acr_values: 'strongAuth4000Service',
  },
  b2d: {
    serverURL: 'https://ross-applications-i.aws.bmw.cloud/api/ross/icd/v1',
    oauthDomainURL: 'https://us.int.alpha.sso.bmwgroup.com',
    issuer:
      'https://us.int.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha',
    redirectUri: 'https://ross-applications-i.aws.bmw.cloud',
    clientId: 'c3add810-aae6-4c12-8ebe-bb32080ac5c8',
    responseType: 'code',
    scope: 'openid profile email bmwids organization b2xroles b2d',
    loginUrl:
      'https://us.int.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha/authorize',
    requireHttps: true,
    oidc: true,
    showDebugInformation: true,
    userType: 'B2D',
    env: 'INT',
    acr_values: 'strongAuth4000Service',
  },

  domain: domain,
  domainType: domain.includes(B2E_DOMAIN) ? 'b2e' : 'b2d',
  isB2D: domain.includes(B2D_DOMAIN),
  isB2E: domain.includes(B2E_DOMAIN),
};

console.log('current environment ', environment);
